import React, { useState } from 'react';
import { Icon, IconButton, Icons, styled } from '@nextiva/next-ui-components';
import { InformationDialog } from './InformationDialog';

const StyledInfoIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.blueGrey.A400};
  cursor: pointer;
`;

export const InfoDialogButton = (props: {
  dataTestId: string;
  title: string;
  content: string | React.ReactElement;
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        aria-label="info"
        sx={{ ml: 1 }}
        data-testid={`${props.dataTestId}-InfoIconButton`}
        onClick={handleOpen}
      >
        <StyledInfoIcon
          icon={Icons.info}
          data-testid={`${props.dataTestId}-InfoIcon`}
        />
      </IconButton>
      <InformationDialog {...props} open={open} handleClose={handleClose} />
    </>
  );
};
